







































































import * as moment from 'moment';
import * as R from 'ramda';
import Vue from 'vue';

import ClientInput from '@/vue/components/input/Client.vue';
import ProjectInput from '@/vue/components/input/Project.vue';

export default Vue.extend({
  components: {
    'input-client': ClientInput,
    'input-project': ProjectInput,
  },

  data() {
    return {
      clientId: undefined as string | undefined,
      date: undefined as moment.Moment | undefined,
      isPriority: undefined as boolean | undefined,
      note: undefined as string | undefined,
      projectId: undefined as string | undefined,
    };
  },

  methods: {
    validate(evt: Event) {
      evt.preventDefault();

      const ok = R.all(
        R.equals(true),
        R.map((p) => !!p, [this.clientId, this.date, this.projectId]),
      );

      if (ok) {
        this.$emit('next', {
          clientId: this.clientId,
          date: this.date,
          isPriority: this.isPriority,
          note: this.note,
          projectId: this.projectId,
        });
      } else {
        this.$message.error('A required input is missing.');
      }
    },
  },
});
